import { Component, OnDestroy, OnInit } from '@angular/core';
import { TenantService } from '../../../../Services/tenant.service';
import { ReleaseService } from '../Services/release.service';
import { Release } from '@app/Tenant/Applications/Airsweb/Models';
import { TenantConfigurationService } from '../Services/tenant-configuration.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.css'],
    imports: [DatePipe, RouterLink]
})

export class OverviewComponent implements OnInit, OnDestroy {
    loading: boolean = true;
    releases!: Release[];
    hasReleases: boolean = false;
    showTenantSpecificConfiguration: boolean = false;
    tenantSessionTimeout: number | null = null;
    showSessionMaxLengthText: boolean = false;
    private readonly onDestroy = new Subject<void>();

    constructor(
        private readonly releaseService: ReleaseService,
        public readonly tenantService: TenantService,
        private readonly tenantConfigurationService: TenantConfigurationService)
    { }

    ngOnInit(): void {
        this.getReleases();
        this.getTenantSessionTimeout();
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.complete();
    }

    private getReleases(): void {
        this.loading = true;
        this.releaseService.getReleases(this.tenantService.selectedTenant)
            .then((releases: Release[]) => {
                this.releases = releases.sort((a, b) => <any>new Date(b.ReleaseDate) - <any>new Date(a.ReleaseDate));
                this.hasReleases = this.releases.length > 0;
                this.loading = false;
            });
    }

    private getTenantSessionTimeout(): void {
        this.tenantConfigurationService.getTenantSessionTimeout(this.tenantService.selectedTenant.Value)
            .pipe(takeUntil(this.onDestroy))
            .subscribe((sessionTimeout: number | null) => {
                this.tenantSessionTimeout = sessionTimeout;
                this.showTenantSpecificConfiguration = sessionTimeout !== null && sessionTimeout !== 0;
                this.showSessionMaxLengthText = sessionTimeout > 1440;
            });
    }
}
